export function checkAuthorization() {
    return getAuthorization() !== null;
}

export function getAuthorization() {
    let str = localStorage.getItem('authentication');
    if (!str) {
        return null;
    }
    return JSON.parse(str);
}

export function setAuthorization(data) {
    localStorage.setItem('authentication', JSON.stringify(data));
}
